// src/pages/AplicativoDetalle.jsx
import { useParams, Link } from "react-router-dom";
import aplicativosData from "../data/aplicativos";
import ReactMarkdown from "react-markdown";
import "../styles/AplicativoDetalle.css";
export default function AplicativoDetalle() {
    const { nombre } = useParams();
    const data = aplicativosData[nombre];

    if (!data) {
        return (
            <div className="detalle">
                <h1>Aplicativo no encontrado</h1>
                <Link to="/Aplicativos" className="btn volver">Volver</Link>
            </div>
        );
    }

    return (
        <div className="detalle">
            <Link to="/Aplicativos" className="btn volver">← Volver a Aplicativos</Link>
            <img src={data.logo} alt={data.alt} className="detalle__logo" />
            <h1 className="detalle__titulo">{data.nombre}</h1>

            <section className="detalle__section">
                <h2>¿Qué es {data.nombre}?</h2>
                {Array.isArray(data.descripcion) &&
                    data.descripcion.map((parrafo, i) => <p key={i}>{parrafo}</p>)}
            </section>

            {data.secciones &&
                data.secciones.map((sec, i) => (
                    <section key={i} className="detalle__section">
                        <h2>{sec.titulo}</h2>
                        <p>{sec.descripcion}</p>
                        {sec.imagenes && (
                            <div className="detalle__imagenes">
                                {sec.imagenes.map((img, j) => (
                                    <div key={j} className="detalle__imagen-con-pie">
                                        <img src={img} alt={`${sec.alt[j]}`} className="detalle__img" />
                                        {sec.pieImage && sec.pieImage[j] && sec.pieImage[j].tipo === "parrafo" ? (
                                            <ReactMarkdown>{sec.pieImage[j].texto}</ReactMarkdown>
                                        ) : null}
                                    </div>
                                ))}
                            </div>
                        )}

                        {sec.contenido.map((bloque, j) => {
                            if (bloque.tipo === "parrafo") return <ReactMarkdown key={j}>{bloque.texto}</ReactMarkdown>;
                            if (bloque.tipo === "subtitulo") return <h4 key={j}>{bloque.texto}</h4>;
                            if (bloque.tipo === "item") return (
                                <ul key={j} className="detalle__lista">
                                    <li><ReactMarkdown>{bloque.texto}</ReactMarkdown></li>
                                </ul>
                            );
                            if (bloque.tipo === "tabla") return (
                                <table key={j} className="detalle__tabla">
                                    <thead>
                                        <tr>
                                            {bloque.cabeceras.map((head, i) => <th key={i}>{head}</th>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bloque.filas.map((fila, i) => (
                                            <tr key={i}>
                                                {fila.map((col, k) => <td key={k}>{col}</td>)}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            );
                            return null;
                        })}
                    </section>
                ))
            }
        </div>
    );
}
